const natureList = [
  { code: "RESD", value: "Residential" },
  { code: "RET", value: "Retail" },
  { code: "OFF", value: "Office" },
  { code: "IND", value: "Industrial" },
  { code: "HOT", value: "Hotel" },
  { code: "DA", value: "Data Centre" },
  { code: "AA", value: "A&A Works" },
  { code: "OTHERS", value: "Others" },
];
const contractList = [
  { code: "INHOUSE", value: "In-house(Internal Project)", INCOST: "" },
  { code: "JV", value: "JV(External Project)", JVCOST: "" },
  { code: "TEN", value: "Tender Project" },
  { code: "LUMP", value: "Lump Sum" },
  { code: "OTHER", value: "Others", other: "" },
];
const defectList = [
  { code: "DEFECT12", value: "12 / 16 Months" },
  { code: "DEFECT3YEARS", value: "3 Years" },
];
const paymentTermList = [
  { code: "MONTHS", value: "Monthly Progress Payment" },
  { code: "SCH", value: "Scheduled Payment" },
  { code: "ARCH", value: "Architect Certificate" },
];
const docTypesList = [
  { value: "", label: "----- Please Select -----" },
  { value: "ochart", label: "O-chart and Manpower Schedule" },
  { value: "tender", label: "Tender and Design Information Schedule" },
  { value: "tempwork", label: "Temp-work Schedule" },
  { value: "plant", label: "Plant Schedule" },
];
export { natureList, contractList, defectList, paymentTermList, docTypesList };
